import script from "./Design.vue?vue&type=script&setup=true&lang=js"
export * from "./Design.vue?vue&type=script&setup=true&lang=js"

import "./Design.vue?vue&type=style&index=0&id=2d9cf25b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9cf25b"]])

export default __exports__